import React from "react";
import { ConnectedBot } from "./chatAnalyticsService";
import { getBotColor, getPlatformDisplayName, getPlatformIcon } from "./chatAnalyticsPalette";

interface ConnectedBotsListProps {
  bots: ConnectedBot[];
}

const initials = (s: string) =>
  s
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();

const ConnectedBotsList: React.FC<ConnectedBotsListProps> = ({ bots }) => {
  if (bots.length === 0) {
    return (
      <div className="text-center py-4">
        <i className="ti ti-plug-connected-x fs-1 text-muted mb-2" />
        <p className="text-muted mb-0">No bots connected yet</p>
      </div>
    );
  }

  return (
    <div className="ca-bot-list">
      {bots.map((bot, index) => {
        const color = getBotColor(bot.bot_type);
        const icon = getPlatformIcon(bot.bot_type);
        const platformLabel = getPlatformDisplayName(bot.bot_type);
        return (
          <div className="ca-bot-row" key={`${bot.bot_name}-${index}`}>
            {icon ? (
              <span className="ca-bot-mark ca-bot-mark-img">
                <img src={icon} alt={platformLabel} />
              </span>
            ) : (
              <span className="ca-bot-mark" style={{ background: color }}>
                {initials(bot.bot_type || bot.bot_name)}
              </span>
            )}
            <div className="flex-grow-1">
              <div className="ca-bot-name">{bot.bot_name}</div>
              <div className="ca-bot-type">{platformLabel}</div>
            </div>
            <span className="ca-bot-badge" style={{ color, borderColor: color }}>
              Connected
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default ConnectedBotsList;
